import Permissions from '@app/src/auth/permissions'
import navigationLinks from '@app/src/wf-constants/navigationLinks'
import { useFlags } from 'launchdarkly-react-client-sdk'
import React from 'react'
import { useIntl } from 'react-intl'
import type { MenuLinkWrapperProps } from './LegacyMenuWrapper'
import { MenuLinkWrapper } from './LegacyMenuWrapper'
import type { NavbarItemProps } from './LegacyNavbarItems'

const ExpectationsLink: React.FC<NavbarItemProps> = ({ closeMenuDrawer }) => {
  const { formatMessage } = useIntl()
  const { baselineExpectation: showBaselineExpectation } = useFlags()

  if (!showBaselineExpectation) return null

  const menuItems: MenuLinkWrapperProps['menuItems'] = {
    link: navigationLinks.expectations,
    permission: [
      Permissions.SOURCING_USER,
      Permissions.FINANCE_USER,
      Permissions.INVESTMENT_USER,
      Permissions.TRANSPARENCY_USER,
    ],
  }

  return (
    <MenuLinkWrapper
      closeMenuDrawer={closeMenuDrawer}
      menuItems={menuItems}
      title={formatMessage({ id: 'navbar.expectations' })}
    />
  )
}

export default ExpectationsLink
